import { biLogger } from './bi-logger';
import type { FullReportProps, ReportProps } from './types';

const enrichReportProps = (props: ReportProps): FullReportProps => ({
  ...props,
  endpoint: 'headless',
});

export const report = (props: ReportProps) =>
  biLogger.report(enrichReportProps(props));
